<script lang="ts">import { page } from "$app/stores";
import { getSections } from "../data/casino";
import { Background } from "@infinitro/background";
import { cfgToThemeCdnPath, stateFeatureSet, stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, stateShowSidebarMobile, toSiteUrlWithActive } from "@infinitro/global";
import { DropdownArrowIcon, LocalIcon, RemoteIcon } from "@infinitro/icons";
import { menuAutoCollapsed } from "../state";
import SidebarItem from "./sidebar-item.svelte";
let dropdownOpen = $state(false);
let items = $derived(getSections($stateFeatureSet, $loggedIn).filter((item) => !item.authed || $loggedIn));
let casinoUrl = $derived.by(() => toSiteUrlWithActive("/casino/", $page.url.pathname, $loggedIn));
let href = $derived(casinoUrl[0]);
let isActive = $derived(casinoUrl[1]);
let isMenuCollapsed = $state(false);
menuAutoCollapsed.subscribe((value) => {
	dropdownOpen = false;
	isMenuCollapsed = value;
});
const toggleDropdown = (event) => {
	event.preventDefault();
	event.stopPropagation();
	dropdownOpen = !dropdownOpen;
};
let useDefault = $derived($stateUi.sidebar.sidebarStyle === "default");
let useAlternative = $derived($stateUi.sidebar.sidebarStyle === "alternative");
let useAlternative2 = $derived($stateUi.sidebar.sidebarStyle === "alternative2");
let useAlternative4 = $derived($stateUi.sidebar.sidebarStyle === "alternative4");
let useButtonBackgroundImage = $derived($stateUi.button.usebuttonBackgroundImage);
let useDropDownButtonTransparent = $derived($stateUi.sidebar?.dropDownToggleTransparent ?? false);
let useRemoteIcons = $derived($stateUi.sidebar.useRemoteIcons ?? false);
</script>

<div class={`custom-dropdown ${isMenuCollapsed ? 'custom-dropdown-collapsed' : ''}`}>
	<!-- eslint-disable-next-line svelte/no-navigation-without-resolve -- dynamic site URL from toSiteUrlWithActive -->
	<a {href} onclick={() => stateShowSidebarMobile.set(false)}>
		<div
			class:dropdown-toggle-alternative={useAlternative || useAlternative4}
			class:dropdown-toggle-alternative-4={useAlternative4}
			class:dropdown-toggle-alternative-2={useAlternative2}
			class:dropdown-toggle-alternative-2-collapsed={isMenuCollapsed && useAlternative2}
			class={`dropdown-toggle ${dropdownOpen && 'dropdown-toggle-open'} ${isMenuCollapsed ? 'dropdown-toggle-collapsed' : ''}`}
			class:dropdown-toggle-open-alternative-4-casino={useAlternative4 && dropdownOpen}
		>
			{#if useAlternative2 && useButtonBackgroundImage}
				<div class="button-background-image-container">
					<img
						src={cfgToThemeCdnPath('/button/background.png')}
						class="button-background-image"
						alt={$t(Verbiage.illustration_alt, 'alts')}
					/>
				</div>
			{/if}
			<div
				class="d-flex"
				class:active-not-primary={isActive && !$stateUi.layout.useCurrentColorSidebar}
				class:inactive-not-primary={!isActive && !$stateUi.layout.useCurrentColorSidebar}
			>
				{#if useAlternative4}
					<LocalIcon size={22} icon="MobileCasinoIcon" />
				{:else}
					<RemoteIcon
						icon="MobileCasinoIcon"
						size={22}
						active={isActive && !useAlternative4}
						activeColor={useAlternative2 ? 'var(--color-highlight-4)' : 'var(--color-primary-500)'}
					/>
				{/if}
				{#if !isMenuCollapsed}
					<span
						class="dropdown-toggle-text"
						class:active={isActive && $stateUi.layout.useCurrentColorSidebar && !useAlternative4}
						class:active-alternative-2={isActive &&
							$stateUi.layout.useCurrentColorSidebar &&
							useAlternative2}>{$t(Verbiage.casino)}</span
					>
				{/if}
			</div>
			{#if !isMenuCollapsed}
				<button
					id="sidebarDropdown"
					class:arrow-button-alternative={useAlternative || useAlternative4}
					class:arrow-button-alternative-2={useAlternative2}
					class:arrow-button-alternative-4={useAlternative4}
					class="arrow-button {dropdownOpen && 'arrow-button-pressed'}"
					class:dropdown-toggle-transparent={useDropDownButtonTransparent}
					onclick={(e) => toggleDropdown(e)}
				>
					<div class:rotated={dropdownOpen}>
						{#if useRemoteIcons}
							<RemoteIcon icon="ArrowIcon" size={22} />
						{:else if useAlternative4}
							<LocalIcon icon="ArrowIcon" />
						{:else}
							<DropdownArrowIcon />
						{/if}
					</div>
				</button>
			{/if}
		</div>
	</a>
	<div
		class:dropdown-menu-alternative={useAlternative || useAlternative4}
		class:dropdown-menu-alternative-4={useAlternative4}
		class:dropdown-menu-alternative-2={useAlternative2}
		class={`dropdown-menu ${isMenuCollapsed ? 'dropdown-menu-collapsed' : ''}`}
		class:expanded={dropdownOpen}
	>
		{#if useDefault}
			<Background embedSurface medium={true} rounded={true} zIndex="0" />
		{/if}
		{#each items as item, index (item.id ?? item.href)}
			<div
				class={`dropdown-item ${isMenuCollapsed ? 'dropdown-item-collapsed' : ''} ${index === 0 ? 'first-item' : ''}`}
			>
				<SidebarItem
					bind:isMenuCollapsed
					category={item}
					itemIdPrefix="casino"
					activeFullWidth={useAlternative4}
				/>
			</div>
		{/each}
	</div>
</div>

<style>
	.custom-dropdown {
		position: relative;
		width: 100%;
		font-size: 14px;
		font-weight: 400;
}

	.custom-dropdown-collapsed {
		width: 100%;
}

	.dropdown-toggle {
		position: relative;
		z-index: 40;
		display: block;
		height: 40px;
		width: 100%;
		cursor: pointer;
		border-radius: 14px;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		padding: 0.625rem;
		font-size: 14px;
		color: var(--color-text-100);
		font-family: var(--font-main);
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-image: var(--gradient-alternative-4);
}
	.dropdown-toggle-alternative {
		border-color: var(--color-accent-700);
		background-color: var(--color-background-500);
		border-radius: 12px;
		background-image: unset;
}

	.dropdown-toggle-alternative-4 {
		border-width: 0px;
		background-color: var(--color-tertiary-700);
}

	.dropdown-toggle-transparent {
		background-color: transparent !important;
}

	.dropdown-toggle-alternative-2 {
		border-radius: 12px;
		border-style: none;
		background-image: unset;
		background:
			radial-gradient(
				ellipse 120% 200% at left,
				rgb(var(--color-primary-500-rgb) / 0.1) 0%,
				var(--color-primary-500) 100%
			),
			radial-gradient(ellipse 150% 180% at center, transparent 0%, var(--color-primary-500) 100%);
}

	.dropdown-toggle-alternative-2-collapsed {
		justify-content: center;
}

	.dropdown-toggle-alternative-2::before {
		pointer-events: none;
		position: absolute;
		inset: 0px;
		border-radius: 12px;
		padding: 1px;
		content: '';
		background: linear-gradient(
			180deg,
			rgba(var(--color-primary-500-rgb) / 0.8) 0%,
			transparent 100%
		);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
}

	.dropdown-toggle.dropdown-toggle-alternative-2.dropdown-toggle-open {
		border-width: 1px;
		border-color: var(--color-primary-500);
}

	.dropdown-toggle.dropdown-toggle-alternative-2.dropdown-toggle-open::before {
		background: var(--color-primary-500) !important;
		border-bottom-right-radius: 0px;
		border-bottom-left-radius: 0px;
	}

	.dropdown-toggle-text {
		font-size: 14px;
}
	.dropdown-toggle-text.active {
		color: var(--color-primary-500);
}

	.dropdown-toggle-text.active-alternative-2 {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	div.active-not-primary {
		opacity: 1;
}

	div.inactive-not-primary {
		opacity: 0.8;
}

	div.active-not-primary .dropdown-toggle-text {
		font-weight: 600 !important;
	}

	div.inactive-not-primary .dropdown-toggle-text {
		font-weight: 600 !important;
	}

	.arrow-button {
		display: flex;
		height: 24px;
		width: 24px;
		align-items: center;
		justify-content: center;
		border-radius: 9.6px;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		background: var(--gradient-alternative-4);
}

	.arrow-button-alternative {
		margin: -0.5rem;
		border-width: 0px;
		background-color: var(--color-background-500);
		padding: 0.5rem;
		width: unset;
		height: unset;
		background-image: unset !important;
}

	.arrow-button-alternative-4 {
		background-color: var(--color-tertiary-700);
}

	.arrow-button-alternative-2 {
		position: relative;
		border-radius: 4px;
		border-style: none;
		background-color: transparent;
		background-image: unset !important;
}

	.arrow-button-alternative-2::before {
		position: absolute;
		inset: 0px;
		border-radius: 4px;
		padding: 1px;
		content: '';
		background: linear-gradient(
			180deg,
			rgba(255, 255, 255, 0.3) 0%,
			rgba(var(--color-primary-500-rgb) / 0.6) 100%
		);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 2;
}

	.arrow-button div {
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: center;
}

	.arrow-button-pressed {
		background: var(--gradient-main);
}

	.dropdown-toggle-open {
		border-bottom-right-radius: 0px;
		border-bottom-left-radius: 0px;
}

	.dropdown-toggle-open-alternative-4-casino {
		background-color: var(--component-side-bar-dropdown-casino-active-bg);
		color: var(--component-side-bar-dropdown-casino-active-text);
}

	:global(
		.dropdown-toggle-open-alternative-4-casino span,
		.dropdown-toggle-open-alternative-4-casino svg
	) {
		color: var(--component-side-bar-dropdown-casino-active-text) !important;
}

	.dropdown-toggle-collapsed {
		width: 100%;
		justify-content: center;
}

	.dropdown-menu {
		position: relative;
		margin-top: -1.5rem;
		width: 100%;
		overflow: hidden;
		border-radius: 14px;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		background-color: transparent;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		padding-top: 1.25rem;
		transition-property: max-height;
		transition-duration: 500ms;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		max-height: 0;
}

	.dropdown-menu-alternative {
		border-color: var(--color-accent-700);
		border-radius: 12px;
}

	.dropdown-menu-alternative-4 {
		border-width: 0px;
		cursor: default !important;
}

	.dropdown-menu-alternative-4.expanded {
		border-width: 1px;
		border-color: var(--color-neutral-900);
}

	.dropdown-toggle.dropdown-toggle-alternative-4.dropdown-toggle-open {
		border-color: var(--color-neutral-900);
}

	.dropdown-menu-alternative-2 {
		margin-top: -8px;
		display: none;
		border-radius: 8px;
		border-top-left-radius: 0px;
		border-top-right-radius: 0px;
		border-top-width: 0px;
		border-color: var(--color-primary-500);
		padding-top: 0px;
}

	.dropdown-menu-alternative-2.expanded {
		display: block;
}

	.dropdown-menu-collapsed {
		width: 100%;
}

	.dropdown-menu.expanded {
		max-height: 450px;
	}

	.dropdown-item {
		position: relative;
		cursor: pointer;
		background-color: transparent;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		font-size: 14px;
		font-weight: 700;
}

	.dropdown-item:hover {
		color: var(--color-text-100);
}

	.dropdown-item-collapsed {
		display: flex;
		width: 100%;
		justify-content: center;
		padding-left: 0px;
		padding-right: 0px;
}

	.d-flex {
		display: flex;
		align-items: center;
		gap: 0.5rem;
}

	.rotated {
		transform: rotate(180deg);
		transition: transform 0.3s ease;
	}

	.first-item {
		padding-top: 0.5rem;
}

	.dropdown-toggle-alternative-2 > .d-flex,
	.dropdown-toggle-alternative-2 > .arrow-button {
		position: relative;
		z-index: 1;
	}

	.button-background-image-container {
		position: absolute;
		inset: 0px;
		height: 100%;
		width: 100%;
		overflow: hidden;
		border-radius: inherit;
		z-index: 0;
}

	.button-background-image {
		position: absolute;
		top: 0px;
		max-width: 100px;
		opacity: 0.5;
		left: 80%;
		transform: translateX(-50%) translateY(-50%);
		width: 100%;
		height: auto;
		-o-object-fit: cover;
		   object-fit: cover;
}

	.dropdown-toggle-collapsed .button-background-image {
		max-width: 100%;
		max-height: 100%;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
</style>
